var map = {
	"./basket/calendar.svg": 124,
	"./basket/clock.svg": 125,
	"./basket/musement_logo.svg": 91,
	"./basket/people.svg": 126,
	"./basket/star.svg": 127,
	"./feature_icons/ADDVA_ENTRAN.svg": 45,
	"./feature_icons/ADDVA_EXCLUS.svg": 46,
	"./feature_icons/ADDVA_GUIDE.svg": 47,
	"./feature_icons/ADDVA_KIDS.svg": 48,
	"./feature_icons/ADDVA_LOCAL.svg": 49,
	"./feature_icons/ADDVA_MEAL.svg": 50,
	"./feature_icons/ADDVA_PRITOU.svg": 51,
	"./feature_icons/ADDVA_SMALL.svg": 52,
	"./feature_icons/ADDVA_SUBJEC.svg": 53,
	"./feature_icons/ADDVA_TOURAU.svg": 54,
	"./feature_icons/ADDVA_VOUCH.svg": 55,
	"./feature_icons/default_icon.svg": 56,
	"./feature_icons/fast.svg": 57,
	"./feature_icons/free.svg": 58,
	"./feature_icons/istant.svg": 59,
	"./feature_icons/official.svg": 60,
	"./feature_icons/skip.svg": 61,
	"./included.svg": 128,
	"./meeting_point.svg": 62,
	"./not_included.svg": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280;